export default __webpack_public_path__ + "assets/models/a1380c71595220fec108d6119ec2cb8f.glb";